import CustomModal from "../modal";
import SignUp from "../signUp";
import LogIn from "../login";

const AuthModal = ({
  openModal,
  openSignUp,
  openLogIn,
  handleModal,
  handleSignUpModal,
  handleLogInModal,
}) => (
  <CustomModal
    style={{ top: openSignUp ? "15%" : "10%" }}
    width={700}
    show={openModal}
    onCancel={() => handleModal(false)}
  >
    {openSignUp && (
      <SignUp openSignUp={openSignUp} handleSignUpModal={handleSignUpModal} />
    )}
    {openLogIn && (
      <LogIn openLogIn={openLogIn} handleLogInModal={handleLogInModal} />
    )}
    <div className="signUpText mt-3 text-center fs_12">
      {openLogIn && (
        <p className="poppins">
          Don't have an account yet?{" "}
          <span
            onClick={() => handleSignUpModal(true)}
            className="link-dark fw-bold cursor_pointer"
          >
            Sign Up
          </span>
        </p>
      )}
      {openSignUp && (
        <p className="poppins">
          Already have an account?{" "}
          <span
            onClick={() => handleLogInModal(true)}
            className="link-dark fw-bold cursor_pointer poppins"
          >
            Sign In
          </span>
        </p>
      )}
    </div>
  </CustomModal>
);

export default AuthModal;
